module.exports = __webpack_public_path__ + "static/media/flashgbs-3.438053d8.jpg";